// GA4 initialization — gated entirely on a configured Measurement ID.
// No Measurement ID configured -> no script is injected, nothing errors, and the
// existing track() helper (analytics.js) simply no-ops. This completes the GA4
// configuration for the event architecture already in place; it does NOT add a
// competing analytics stack.
//
// Page views: handled entirely by GA4 itself — the gtag "config" command sends the
// initial page_view, and GA4 Enhanced Measurement ("page changes based on browser
// history events") sends page_views for React Router client-side route changes.
// We intentionally do NOT also send manual page_views, which would double-count on
// SPA navigations.
const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let initialized = false;

export function isGA4Enabled() {
  return typeof GA4_ID === "string" && /^G-[A-Z0-9]+$/i.test(GA4_ID);
}

export function initGA4() {
  if (initialized || !isGA4Enabled() || typeof window === "undefined") return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA4_ID);
}
